import { GET_REQUIRED_ONBOARDING } from 'pricing-pages-api/required-onboarding/queries';
import { REQUIRED_ONBOARDING as EARLY_REQUEST_REQUIRED_ONBOARDING } from 'pricing-pages-lib/constants/EarlyRequesterNames';
import { REQUIRED_ONBOARDING } from './constants/RequestedDataTypes';
import { createRequestActions, createRequestTypes } from './helpers/RequestActions';
import { dataFetchingClient } from '../utils/dataFetchingClient';
import makeFetchRequest from './helpers/makeFetchRequest';
export const FetchRequiredOnboardingRequestTypes = createRequestTypes(REQUIRED_ONBOARDING);
export const FetchRequiredOnboardingActions = createRequestActions(FetchRequiredOnboardingRequestTypes);
export const fetchRequiredOnboarding = () => makeFetchRequest({
  requestActions: FetchRequiredOnboardingActions,
  fetch: async () => {
    const response = await dataFetchingClient.query({
      query: GET_REQUIRED_ONBOARDING,
      variables: {
        earlyRequestName: EARLY_REQUEST_REQUIRED_ONBOARDING
      }
    });
    return response === null || response === void 0 ? void 0 : response.data;
  }
});